<template>
    <router-view />
</template>

<script>
    export default {
        name: "StudentScriptLayout"
    }
</script>

<style scoped>

</style>